/**
 * Evaluate something that could be either a normal value or a function that produces that value
 * @param property the value or function to be evaluated
 * @param args arguments to pass in to the function when evaluating
 * @returns {*}
 */
export default function evaluateFunctionOrValue(property, ...args) {
  return typeof property === 'function' ? property(...args) : property;
}
